import { ISearchParamName, ISearchParamNameAndValue, SearchParamName } from '@cbridge-packages/routing';

export namespace ServerParam {
  export const name: ISearchParamName = {
    name: SearchParamName.Server,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}
